import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, useRef } from 'react';
import { useMergeRefs } from '@floating-ui/react';
import { TextFieldBase } from '../TextFieldBase';
export const TextAreaField = forwardRef(function TextAreaField(props, forwardedRef) {
    const { inputRef: inputRefProp, ...other } = props;
    const inputRef = useRef(null);
    const inputHandleRef = useMergeRefs([inputRef, inputRefProp]);
    const inputRenderer = ({ getStyles, ref, forwardedProps, modifiers, onValueChange }) => (_jsx("textarea", { ...getStyles('input', modifiers.hasError && 'input$error', modifiers.disabled && 'input$disabled'), disabled: modifiers.disabled, ...forwardedProps, onChange: (event) => {
            forwardedProps?.onChange?.(event);
            onValueChange?.(event.target.value, event.target);
        }, ref: ref }));
    return (_jsx(TextFieldBase, { ...other, ref: forwardedRef, textArea: true, inputRef: inputHandleRef, onClear: () => {
            if (inputRef.current?.value) {
                inputRef.current.value = '';
            }
        }, forwardProps: true, inputRenderer: inputRenderer }));
});
